import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import PageList from '#/modules/commonComponents/PageList';
import { can } from '#/modules/infra/auth/can';
import crmMgmtNavigate from '#/modules/infra/navigation/crmMgmtNavigate';

const CrmMgmtHubPage = () => {
  const permissions = useSelector((state) => state.infra.permissions);
  const linkList = useMemo(
    () => crmMgmtNavigate.filter(
      (item) => !item.permission || can(permissions, item.permission),
    ),
    [permissions],
  );

  return <PageList title="客戶管理" linkList={linkList} />;
};

export default CrmMgmtHubPage;
